export default async function loadStylesheet(
  url: string,
  id?: string,
  attributes: Record<string, string> = {}
) {
  if (id && document.getElementById(id)) {
    return;
  }

  return new Promise((res) => {
    const first =
      document.getElementsByTagName('link')?.[0] || document.getElementsByTagName('script')?.[0];
    if (!first?.parentNode) {
      return;
    }

    const entry = document.createElement('link');
    entry.rel = 'stylesheet';
    entry.onload = res;
    entry.href = url;
    if (id) {
      entry.id = id;
    }

    Object.keys(attributes).forEach((name) => {
      const value = attributes[name];
      entry.setAttribute(name, value);
    });

    first.parentNode.insertBefore(entry, first);
  });
}
